<template>
  <div>
    <FormulateInput
        v-model="element.multiple"
        type="checkbox"
        label="Meerdere afbeeldingen toestaan"
        help="Vink dit veld aan als u wilt toestaan dat de gebruiker meerdere afbeeldingen kan uploaden."
    />
    <FormulateInput
        v-model="element.useOnlyCamera"
        type="checkbox"
        label="Alleen fotos vanaf camera maken"
        help="Vink dit veld aan als de gebruiker alleen fotos mag uploaden die direct vanaf de camera komen."
    />
    <FormulateInput
        v-model="element.hdImages"
        type="checkbox"
        label="Bewaar HD afbeeldingen"
        help="Vink dit veld aan als u de afbeeldingen in HD kwaliteit wilt bewaren."
    />
  </div>
</template>

<script>
export default {
  name: 'EformElementEditImage',
  props: {
    element: Object,
  },
  data () {
    return {
      helpTextMultiple: 'U kunt meerdere foto\'s uploaden. ',
    }
  },
  watch: {
    'element.multiple': function (newVal) {
        this.updateLabelAndHelp(newVal)
    },
  },
  methods: {
    updateLabelAndHelp(isMultiple) {
      if (isMultiple) {
        // Prepend the multiple help text if it's not already there
        this.element.help = this.helpTextMultiple + this.element.help;
        if (this.element.label === 'Foto') {
          this.element.label = 'Foto\'s';
        }
      }
      else {
        // Remove the multiple help text if it exists
        this.element.help = this.element.help.replace(this.helpTextMultiple, '')
        if (this.element.label === 'Foto\'s') {
          this.element.label = 'Foto';
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
